import React, {useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import {useThemeMode} from '../../../../../../_metronic/partials'
import '../../../Style/Style.css'
import * as Yup from 'yup'
import {useLocation, useNavigate} from 'react-router-dom'
import {
  findAllEstatus,
  findAllOrgVentas,
  findOneContactenos,
  updateContactenos,
} from '../../../models/_requests'
import {useFormik} from 'formik'
import Swal from 'sweetalert2'
import dayjs from 'dayjs'
import {RegistroEstatus, RegistroOrgVentas} from '../../../models/_models'
import {useIntl} from 'react-intl'
import {RegistroFuncionalidad, useAuth} from '../../../../auth'
import {getNodoByNivel} from '../../../models/helpers'

const contactenosSchema = Yup.object().shape({
  Nombres: Yup.string()

    .max(50, 'Maximo 50 caracteres')
    .required('nombre es requerido'),
  Apellidos: Yup.string()

    .max(240, 'Maximo 240 caracteres')
    .required('apellido es requerido'),
  // Celular: Yup.string()
  //   .matches(/^\d+$/, 'Phone number must contain only numbers')
  //   .matches(/^9/, 'Phone number must start with 9')
  //   .matches(/^\d{9}$/, 'The phone number must be 9 digits')
  //   .max(9, 'Maximo 9 numbers')
  //   .required('celular es requerido'),
  // Email: Yup.string().email('Wrong email format').required('email es requerido'),

  Celular: Yup.string()
    .matches(/^\d+$/, 'El celular debe contener solo dígitos') // Asegura que sean solo dígitos
    .max(12, 'El celular debe tener como máximo 12 dígitos') // Permite un máximo de 12 caracteres
    .required('Celular es requerido'),
  Email: Yup.string()
    .email('Debe ser un Email válido') // Valida que sea un email correcto
    .required('Email es requerido'),

  Mensaje: Yup.string()

    .max(240, 'Maximo 240 caracteres')
    .required('mensaje es requerido'),
  IdEstatus: Yup.number().moreThan(0, 'estatus es requerido').required('estatus es requerido'),
  Activo: Yup.boolean().required('activo es requerido'),
})

const ViewContactenos: React.FC = () => {
  const addMinutes = Number(process.env.REACT_APP_MINUTES)
  const addSecond = Number(process.env.REACT_APP_SECOND)

  const {mode} = useThemeMode()
  const navigate = useNavigate()
  const {state}: any = useLocation()
  const [estado, setEstado] = useState<boolean>(false)
  const [flag, setFlag] = useState<boolean>(false)
  const [loadingButton, setLoadingButton] = useState(false)
  const [loadingData, setLoadingData] = useState(false)
  const intl = useIntl()

  const [id, setId] = useState(0)
  const [nombres, setNombres] = useState('')
  const [apellidos, setApellidos] = useState('')
  const [celular, setCelular] = useState('')
  const [mensaje, setMensaje] = useState('')
  const [email, setEmail] = useState('')
  const [idOrgVentas, setIdOrgVentas] = useState('')
  const [orgVentas, setOrgVentas] = useState('')

  const [idEstatus, setIdEstatus] = useState(0)
  const [estatus, setEstatus] = useState('')
  const [activo, setActivo] = useState(false)

  const [creadoPor, setCreadoPor] = useState('')
  const [creadoEl, setCreadoEl] = useState('')
  const [modificadoPor, setModificadoPor] = useState('')
  const [modificadoEl, setModificadoEl] = useState('')

  const [dataEstatus, setDataEstatus] = useState<RegistroEstatus[]>([])

  const getDataEstatus = async () => {
    const value = {
      cantidad_max: '0',
      Language: intl.locale.toUpperCase(),
      filters: [
        {
          campo: 'IdEsquemaEstatus',
          operador: 'EQ',
          tipo: 'string',
          valor1: '2',
          valor2: '',
        },
      ],
    }

    try {
      const {data: list} = await findAllEstatus(value)
      if (list.message.msgId == 0) {
        setDataEstatus(list.registro)
      } else {
        setDataEstatus([])
      }
    } catch (error) {
      console.error(error)
    }
  }

  const [dataOrgVentas, setDataOrgVentas] = useState<RegistroOrgVentas[]>([])

  const getDataOrgVentas = async () => {
    const filters = {
      cantidad_max: '0',
      Language: 'ES',
      filters: [
        {
          campo: 'IdOrgSaas',
          operador: 'EQ',
          tipo: 'numeric2',
          valor1: currentUser ? currentUser.registro.IdOrgSaas.toString() : '',
          valor2: '',
        },
      ],
    }

    try {
      const {data: list} = await findAllOrgVentas(
        filters,
        currentUser ? currentUser.registro.IdOrgV : '',
        currentUser ? currentUser.registro.IdRol : ''
      )
      if (list.message.msgId == 0) {
        setDataOrgVentas(list.registro)
      } else {
        setDataOrgVentas([])
      }
    } catch (error) {
      console.error(error)
    }
  }

  const getData = async () => {
    setLoadingData(true)
    try {
      const {data: value} = await findOneContactenos(state.id_contactenos)

      if (value.message.msgId == 0) {
        setId(value.registro.IdContactenos)
        setNombres(value.registro.Nombres)
        setApellidos(value.registro.Apellidos)
        setCelular(value.registro.Celular)
        setEmail(value.registro.Email)
        setMensaje(value.registro.Mensaje)

        setIdOrgVentas(value.registro.IdOrgV ? value.registro.IdOrgV : '')
        setOrgVentas(value.registro.orgventas ? value.registro.orgventas.Descripcion : '')

        setIdEstatus(value.registro.IdEstatus ? value.registro.IdEstatus : 0)
        setEstatus(value.registro.estatus ? value.registro.estatus.Descripcion : '')
        setActivo(value.registro.Activo)

        setCreadoPor(value.registro.CreadoPor ? value.registro.CreadoPor : '')
        setCreadoEl(
          value.registro.CreadoEl
            ? dayjs(value.registro.CreadoEl)
                .add(addMinutes, 'minute')
                .add(addSecond, 'second')
                .format('MMM DD, YYYY h:mm A')
            : ''
        )
        setModificadoPor(value.registro.ModificadoPor ? value.registro.ModificadoPor : '')

        setModificadoEl(
          value.registro.ModificadoEl
            ? dayjs(value.registro.ModificadoEl)
                .add(addMinutes, 'minute')
                .add(addSecond, 'second')
                .format('MMM DD, YYYY h:mm A')
            : ''
        )

        formik.setValues({
          Nombres: value.registro.Nombres,
          Apellidos: value.registro.Apellidos,
          Celular: value.registro.Celular,
          Email: value.registro.Email,
          Mensaje: value.registro.Mensaje,
          IdEstatus: value.registro.IdEstatus ? value.registro.IdEstatus : 0,
          IdOrgV: value.registro.IdOrgV ? value.registro.IdOrgV : '',
          Activo: value.registro.Activo,
        })
      }
    } catch (error) {
      console.error(error)
    }
    setLoadingData(false)
  }

  const formik = useFormik({
    initialValues: {
      Nombres: nombres,
      Apellidos: apellidos,
      Celular: celular,
      Email: email,
      Mensaje: mensaje,
      IdEstatus: idEstatus,
      IdOrgV: idOrgVentas,
      Activo: activo,
    },

    validationSchema: contactenosSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoadingButton(true)

      try {
        const {data: update} = await updateContactenos(
          id,
          values.Nombres,
          values.Apellidos,
          values.Mensaje,
          values.Celular,
          values.Email,
          Number(values.IdEstatus),
          values.IdOrgV,
          values.Activo
        )

        if (update.message.msgId == 0) {
          Swal.fire({
            icon: 'success',
            title: 'Actualizado!',
            text: `${update.message.msgTxt}`,
            showConfirmButton: false,
            timer: 3000,
          })
          setFlag(!flag)
          formik.setValues({
            Nombres: update.registro.Nombres,
            Apellidos: update.registro.Apellidos,
            Celular: update.registro.Celular,
            Email: update.registro.Email,
            Mensaje: update.registro.Mensaje,
            IdEstatus: update.registro.IdEstatus ? update.registro.IdEstatus : 0,
            IdOrgV: update.registro.IdOrgV ? update.registro.IdOrgV : '',
            Activo: update.registro.Activo,
          })
          setEstado(false)
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops... Ocurrio un error',
            text: `${update.message.msgTxt}`,
            showConfirmButton: false,
            timer: 3000,
          })
        }
      } catch (error) {
        console.error(error)

        setSubmitting(false)
      }

      setLoadingButton(false)
    },
  })

  const handleEditar = () => {
    setEstado(true)
  }

  const handleCancelar = () => {
    setEstado(false)
  }

  useEffect(() => {
    getData()
  }, [flag])

  useEffect(() => {
    getDataEstatus()
    getDataOrgVentas()
  }, [])

  const [registroFuncionalidad, setRegistroFuncionalidad] = useState<RegistroFuncionalidad | null>(
    null
  )

  const {currentUser} = useAuth()

  const funcionalidad = getNodoByNivel(12, 0, currentUser)

  useEffect(() => {
    if (funcionalidad) {
      console.log(funcionalidad)
      setRegistroFuncionalidad(funcionalidad)
    }
  }, [registroFuncionalidad])

  return (
    <div className={'card'}>
      <form
        onSubmit={formik.handleSubmit}
        noValidate
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      >
        <div className='row g-5 g-xl-8 '>
          <div className='col-xl-12 '>
            <div className='card-body d-flex flex-column  pt-3 mt-15 pb-0'>
              <h3 className='card-title fs-1  flex-column text-center'>
                {intl.formatMessage({id: 'CONTACTUS_DATA'})}
              </h3>

              <div>
                {loadingData ? (
                  <>
                    <div
                      className='d-flex flex-column align-items-center justify-content-center'
                      style={{height: '200px'}}
                    >
                      <span
                        className='indicator-progress text-gray-700 fw-bolder fs-1'
                        style={{display: 'block'}}
                      >
                        Cargando datos...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    <div className='row mb-1'>
                      <div className='col-lg-3'>
                        <label className='col-lg-12 col-form-label fw-bold fs-6'>
                          <span className=''>Id</span>
                        </label>

                        {estado ? (
                          <div className='col-lg-6  mt-3'>
                            <span className='fs-6 me-2'>{id}</span>
                          </div>
                        ) : (
                          <div className='col-lg-12  '>
                            <span className='fs-6 me-2'>{id}</span>
                          </div>
                        )}
                      </div>

                      <div className='col-lg-3'>
                        <label className='col-lg-12 col-form-label fw-bold fs-6'>Nombres</label>

                        {estado ? (
                          <div className='col-lg-12 fv-row'>
                            <input
                              type='text'
                              className={`form-control  ${
                                mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                              } `}
                              placeholder='nombre'
                              {...formik.getFieldProps('Nombres')}
                              value={formik.values.Nombres}
                            />
                            {formik.touched.Nombres && formik.errors.Nombres && (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block fw-bold  mx-3'>
                                  {formik.errors.Nombres}
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className='col-lg-12 fv-row   '>
                            <span className='fs-6 '>{nombres}</span>
                          </div>
                        )}
                      </div>

                      <div className='col-lg-3'>
                        <label className='col-lg-12 col-form-label fw-bold fs-6'>Apellidos</label>

                        {estado ? (
                          <div className='col-lg-12 fv-row'>
                            <input
                              type='text'
                              className={`form-control  ${
                                mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                              } `}
                              placeholder='apellidos'
                              {...formik.getFieldProps('Apellidos')}
                              value={formik.values.Apellidos}
                            />
                            {formik.touched.Apellidos && formik.errors.Apellidos && (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block fw-bold  mx-3'>
                                  {formik.errors.Apellidos}
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className='col-lg-12 fv-row   '>
                            <span className='fs-6 '>{apellidos}</span>
                          </div>
                        )}
                      </div>

                      <div className='col-lg-3'>
                        <label className='col-lg-12 col-form-label fw-bold fs-6'>Celular</label>

                        {estado ? (
                          <div className='col-lg-12 fv-row'>
                            <input
                              type='tel'
                              className={`form-control  ${
                                mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                              } `}
                              placeholder='Celular'
                              {...formik.getFieldProps('Celular')}
                            />
                            {formik.touched.Celular && formik.errors.Celular && (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block fw-bold  mx-3'>
                                  {formik.errors.Celular}
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className='col-lg-12 fv-row   '>
                            <span className='fs-6 '>{celular}</span>
                          </div>
                        )}
                      </div>

                      <div className='col-lg-3'>
                        <label className='col-lg-12 col-form-label fw-bold fs-6'>Email</label>

                        {estado ? (
                          <div className='col-lg-12 fv-row'>
                            <input
                              type='email'
                              className={`form-control  ${
                                mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                              } `}
                              placeholder='Email'
                              {...formik.getFieldProps('Email')}
                            />
                            {formik.touched.Email && formik.errors.Email && (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block fw-bold  mx-3'>
                                  {formik.errors.Email}
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className='col-lg-12 fv-row   '>
                            <span className='fs-6 '>{email}</span>
                          </div>
                        )}
                      </div>

                      <div className='col-lg-6'>
                        <label className='col-lg-12 col-form-label fw-bold fs-6'>Mensaje</label>

                        {estado ? (
                          <div className='col-lg-12 fv-row'>
                            <input
                              type='text'
                              className={`form-control  ${
                                mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                              } `}
                              placeholder='Mensaje'
                              {...formik.getFieldProps('Mensaje')}
                            />
                            {formik.touched.Mensaje && formik.errors.Mensaje && (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block fw-bold  mx-3'>
                                  {formik.errors.Mensaje}
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className='col-lg-12 fv-row   '>
                            <span className='fs-6 '>{mensaje}</span>
                          </div>
                        )}
                      </div>

                      <div className='col-lg-3'>
                        <label className='col-lg-12 col-form-label fw-bold fs-6'>Estatus</label>

                        {estado ? (
                          <div className='col-lg-12 fv-row'>
                            <select
                              className={`form-select  ${
                                mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                              } `}
                              {...formik.getFieldProps('IdEstatus')}
                            >
                              <option value={''}>Seleccione estatus...</option>
                              {dataEstatus.map((option) => (
                                <option key={option.IdEstatus} value={option.IdEstatus}>
                                  {option.Descripcion}
                                </option>
                              ))}
                            </select>
                            {formik.touched.IdEstatus && formik.errors.IdEstatus && (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block fw-bold  mx-3'>
                                  {formik.errors.IdEstatus}
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className='col-lg-12 fv-row   '>
                            <span className='fs-6 '>{estatus}</span>
                          </div>
                        )}
                      </div>

                      <div className='col-lg-3'>
                        <label className='col-lg-12 col-form-label fw-bold fs-6'>
                          Organización Ventas
                        </label>

                        {estado ? (
                          <div className='col-lg-12 fv-row'>
                            <select
                              className={`form-select  ${
                                mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                              } `}
                              {...formik.getFieldProps('IdOrgV')}
                              disabled={true}
                            >
                              <option value=''>Seleccione org ventas...</option>
                              {dataOrgVentas.map((option) => (
                                <option key={option.IdOrgV} value={option.IdOrgV}>
                                  {option.Descripcion}
                                </option>
                              ))}
                            </select>
                            {formik.touched.IdOrgV && formik.errors.IdOrgV && (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block fw-bold  mx-3'>
                                  {formik.errors.IdOrgV}
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className='col-lg-12  '>
                            <span className='fs-6 me-2'>{orgVentas}</span>
                          </div>
                        )}
                      </div>

                      <div className='col-lg-3'>
                        <label className='col-lg-12 col-form-label fw-bold fs-6'>Activo</label>

                        {estado ? (
                          <div className='col-lg-12 fv-row'>
                            <select
                              className={`form-select  ${
                                mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                              } `}
                              value={formik.values.Activo ? 'Si' : 'No'}
                              onChange={(e) => {
                                formik.setFieldValue('Activo', e.target.value === 'Si')
                              }}

                              // onChange={(e) => {
                              //   formik.setFieldValue('Activo', e.target.value === 'Si' ? true : false)
                              // }}
                            >
                              <option value={'Si'}>Si</option>
                              <option value={'No'}>No</option>
                            </select>
                            {formik.touched.Activo && formik.errors.Activo && (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block fw-bold  mx-3'>
                                  {formik.errors.Activo}
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className='col-lg-12 fv-row   '>
                            <span className='fs-6 '>{activo == true ? 'Si' : 'No'}</span>
                          </div>
                        )}
                      </div>

                      <div className='col-lg-3'>
                        <label className='col-lg-12 col-form-label fw-bold fs-6'>
                          <span className=''>Creado por</span>
                        </label>

                        {estado ? (
                          <div className='col-lg-12  mt-3'>
                            <span className='fs-6 me-2'>{creadoPor}</span>
                          </div>
                        ) : (
                          <div className='col-lg-12  '>
                            <span className='fs-6 me-2'>{creadoPor}</span>
                          </div>
                        )}
                      </div>

                      <div className='col-lg-3'>
                        <label className='col-lg-12 col-form-label fw-bold fs-6'>
                          <span className=''>Creado el</span>
                        </label>

                        {estado ? (
                          <div className='col-lg-12 mt-3'>
                            <span className='fs-6 me-2'>{creadoEl}</span>
                          </div>
                        ) : (
                          <div className='col-lg-12  '>
                            <span className='fs-6 me-2'>{creadoEl} </span>
                          </div>
                        )}
                      </div>

                      <div className='col-lg-3'>
                        <label className='col-lg-12 col-form-label fw-bold fs-6'>
                          <span className=''>Modificado por</span>
                        </label>

                        {estado ? (
                          <div className='col-lg-12  mt-3'>
                            <span className='fs-6 me-2'>{modificadoPor}</span>
                          </div>
                        ) : (
                          <div className='col-lg-12  '>
                            <span className='fs-6 me-2'>{modificadoPor}</span>
                          </div>
                        )}
                      </div>

                      <div className='col-lg-3'>
                        <label className='col-lg-12 col-form-label fw-bold fs-6'>
                          <span className=''>Modificado el</span>
                        </label>

                        {estado ? (
                          <div className='col-lg-12  mt-3'>
                            <span className='fs-6 me-2'>{modificadoEl}</span>
                          </div>
                        ) : (
                          <div className='col-lg-12  '>
                            <span className='fs-6 me-2'>{modificadoEl}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className='row my-5 me-1  '>
          <div className='d-flex justify-content-end'>
            {registroFuncionalidad?.Modificar && (
              <>
                {!estado && (
                  <button
                    type='button'
                    className='btn btn-success px-10 me-2'
                    onClick={handleEditar}
                  >
                    Editar
                  </button>
                )}
              </>
            )}

            {estado && (
              <>
                <button
                  type='button'
                  className='btn btn-secondary px-10 me-2 '
                  onClick={handleCancelar}
                >
                  Cancelar
                </button>
                <button
                  type='submit'
                  className='btn btn-primary px-10 '
                  disabled={formik.isSubmitting || !formik.isValid}
                >
                  {!loadingButton && 'Actualizar'}
                  {loadingButton && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Espere por favor...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </>
            )}
          </div>
        </div>
      </form>
    </div>
  )
}

export {ViewContactenos}
